import { forwardRef, useId } from "react";
import type { IconsaxProps } from "./Iconsax.types.js";

export const AddLinear = forwardRef<HTMLDivElement, IconsaxProps>(({ size = 24, color = "currentColor", ...rest }, ref) => {
    const clipId = useId();
    return (
        <div ref={ref} {...rest} style={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", ...rest.style }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath={`url(#${clipId})`}>
                    <path d="M6 12H18" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M12 18V6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                    <clipPath id={clipId}>
                        <rect width="24" height="24" fill="none" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
});
